<template>
  <div>
    <UserMenu />
    <div class="page">
      <header>
        <slot name="header"></slot>
      </header>
      <main>
        <slot name="main"></slot>
      </main>
    </div>
  </div>
</template>
<script>
import UserMenu from '@/components/menu';
export default {
  name: 'page_layout',
  components: { UserMenu }
};
</script>
